// extracted by mini-css-extract-plugin
export default {"text":"AdminDeleteModal_text__-x694","footer":"AdminDeleteModal_footer__k-3tB"};